import Backbone from 'backbone';
import SocialLinksModel from './socialLinksModel';
const TargetSiteModel = Backbone.Model.extend({
    idAttribute: 'uuid',
    url: '',
    defaults: {
        uuid: '',
        created: null,
        version: 1,
        name: '',
        imageUrl: '',
        url: '',
        stagingUrl: '',
        callLetters: '',
        status: '',
        city: '',
        state: '',
        zipcode: '',
        timezone: '',
        includedSources: null,
        excludedSources: null,
        savedDate: null,
        scheduledDate: null,
        expiresDate: null,
        publishAuthorizationDate: null,
        unpublishAuthorizationDate: null,
        siteSlug: null,
        siteType: null,
        brandUuid: '',
        channel: '',
        network: '',
        brandColorOne: '',
        brandColorTwo: '',
        backgroundColorOne: '',
        backgroundColorTwo: '',
        textColorOne: '',
        textColorTwo: '',
        textColorThree: '',
        textColorFour: '',
        headerLogoImageUrl: '',
        footerLogoImageUrl: '',
        galleryLogoImageUrl: '',
        faviconImageUrl: '',
        weatherImageOneUrl: '',
        weatherImageTwoUrl: '',
        fontUrl: null,
        designatedMarketArea: '',
        dfpNetworkId: '',
        dfpAdUnitId: '',
        googleAnalyticsId: '',
        general: null,
        theme: null,
        integration: null,
        sources: null,
        social: null,
        affiliate: null,
    },
    blacklist: ['id'],
    initialize(data) {
        if (data) {
            this.set(data);
            this.set('includedSources', new Backbone.Collection(data.includedSources));
            this.set('excludedSources', new Backbone.Collection(data.excludedSources));
            this.set('social', new SocialLinksModel(data.social));
        }
    },
});

export default TargetSiteModel;
